export const NOTIFICATION_SETTINGS = [
  {
    setting: 'Account Reminders & Mentions',
    topic: 'accountReminders',
    text: 'Get periodic reminders and nudges to complete your account setup and connect with your students.',
  },
  {
    setting: 'Raise Me tips + lesson plans',
    topic: 'tipsAndLessonPlans',
    text: "Don't miss the chance to hear updates on how to best utilize Raise Me on your students’ path to college success.",
  },
  {
    setting: 'Student stats, updates, and usage recommendations',
    topic: 'studentStatsAndUpdates',
    text: "Let's be real, why would you unsub from this? Know your students’ engagement and help your students find their ideal school and scholarship program.",
  },
  {
    setting: 'Blog digest, news & marketing emails',
    topic: 'blogAndNews',
    text: 'Get the latest content created by our Educator partnerships team straight to your inbox.',
  },
  {
    setting: 'Contest and promotion emails',
    topic: 'contestAndPromotions',
    text: 'You and your students could... win all the swag! Compete against other schools! Earn more for your school!',
  },
  {
    setting: 'Critical deadline reminders',
    topic: 'criticalDeadlineReminders',
    text: 'Not recommended to unsubscribe. These notifications are critical for submissions deadlines to colleges for your students.',
  },
];
